import { configureStore } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';

import rootReducer, {
  fromAccounts,
  fromAccountUsers,
  fromAuth,
  fromBillingInformation,
  fromInvoices,
  fromLayout,
  fromOrder,
  fromPaymentMethod,
  fromSubscription,
  fromSurvey,
  fromUsers,
  fromOrganizations,
  fromAccountFeatureFlag,
  fromOrganizationFeatureFlag,
  fromPromotion,
} from './rootReducer';

const isDevelopment = process.env.NODE_ENV === 'development';
const store = configureStore({
  reducer: rootReducer,
  devTools: isDevelopment,
});

if (isDevelopment && module.hot) {
  module.hot.accept('./rootReducer', () => {
    // eslint-disable-next-line global-require
    const newRootReducer = require('./rootReducer').default;
    store.replaceReducer(newRootReducer);
  });
}

export type AppState = ReturnType<typeof rootReducer>;
export const useAppDispatch = () => useDispatch<typeof store.dispatch>();

export {
  fromAccounts,
  fromAccountUsers,
  fromAuth,
  fromBillingInformation,
  fromInvoices,
  fromLayout,
  fromOrder,
  fromPaymentMethod,
  fromSubscription,
  fromSurvey,
  fromUsers,
  fromOrganizations,
  fromAccountFeatureFlag,
  fromOrganizationFeatureFlag,
  fromPromotion,
};

export default store;
